<template>
  <div class="dashboard-chart">
    <div v-if="!loading" class="dashboard-chart-content">
      <dashboard-bar-chart :data="data" />
    </div>
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import DashboardBarChart from './DashboardBarChart'

export default {
  name: 'WorkStandards',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    data: {
      type: Array,
      default: () => ([])
      // Example: [{ label: 'Work management', value: 50 }]
    }
  },

  components: {
    DashboardBarChart
  }
}
</script>
